import { createEntityAdapter, createSlice, EntityState } from '@reduxjs/toolkit';
import { setUserProfile } from '../actions/userAction';
import { IUserContext } from '../../interfaces/ManageView';
import { UserMetadata } from '../../interfaces/UserMetadataResponse';
import { getViewsDataApi } from 'src/features/HubOverview/store/service/multitenantDashboardApi';

const userMetadataByTenantAdapter = createEntityAdapter<UserMetadata>({
  selectId: (metadata: UserMetadata) => metadata.TenantId, // Set the key for the entity to be tenant id
});

export interface IUserProfileContext {
  userProfile: IUserContext;
  userMetadataByTenant: EntityState<UserMetadata, string>;
}

const initialState: IUserProfileContext = {
  userMetadataByTenant: userMetadataByTenantAdapter.getInitialState(),
  userProfile: {
    displayName: '',
    authorization: '',
    flights: [],
    givenName: '',
    email: '',
    lastName: '',
    hasTeam: false,
    persona: '',
    displayColumns: {
      displayColumnOptions: [],
      owner: '',
      id: '',
    },
    views: [],
    userSettings: {},
    isUserExcluded: '',
    isUserInOrg: '',
    areapaths: [],
  },
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setUserProfile, (state, action) => {
      state.userProfile = action.payload;
    });
    builder.addMatcher(
      getViewsDataApi.endpoints.getUserMetadata.matchFulfilled,
      (state, action) => {
        userMetadataByTenantAdapter.upsertMany(state.userMetadataByTenant, action.payload);
      }
    );
    builder.addMatcher(
      getViewsDataApi.endpoints.createUserMetadata.matchFulfilled,
      (state, action) => {
        userMetadataByTenantAdapter.upsertOne(state.userMetadataByTenant, action.payload);
      }
    );
  },
});

export default userSlice.reducer;
